.spaHeader {
	padding-left: var(--jpo-common-base-spacing);
	height: 50px;
	line-height: 50px;
	background-color: var(--ds-background-neutral, var(--adg3-color-N20));
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N50));
	box-sizing: border-box;
	&.selected {
		background-color: var(--ds-background-neutral, var(--adg3-color-N20));
	}
}

.spaBottomHeader {
	padding-left: var(--jpo-common-base-spacing);
	height: 40px;
	display: flex;
	align-items: center;
	gap: var(--jpo-common-base-spacing);
	&.selected {
		background-color: var(--ds-background-neutral, var(--adg3-color-N20));
	}
}

div.scope-row {
	height: 100%;
	padding: 0;
}

.rankHeader {
	color: var(--ds-text-subtlest, var(--adg3-color-subtleText-light));
	display: inline-flex;
	padding-right: 12px;
}

.issueHeader {
	color: var(--ds-text-subtlest, var(--adg3-color-subtleText-light));
	display: inline-flex;
}

div.left {
	min-width: 80px;
	display: flex;
	align-items: center;
}

.bulkActions {
	margin: 0 calc(var(--jpo-common-base-spacing) * 2) 0 0;
}
